import React from 'react';
import { Modal } from 'react-bootstrap';


function WarningModal(props) {


    return (
        <>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Body className='text-center'>
                    <i class="fa-solid fa-circle-exclamation" style={{ fontSize: "80px", marginBottom: "20px", color: "red" }}></i>
                    <p className='swal-text'>
                        {props.message}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={props.cancel}>Yes</button>
                    <button className="btn btn-secondary" onClick={props.onHide}>No</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default WarningModal;


